import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.trash[ownProps.id-1].type,
    open: state.notebook.protocolSection.scene.apparatus.trash[ownProps.id-1].open,
    full: state.notebook.protocolSection.scene.apparatus.trash[ownProps.id-1].full,
    count: state.notebook.protocolSection.scene.apparatus.trash[ownProps.id-1].count
  }
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
